import { Price } from '@pancakeswap/sdk'
import { Text, AutoRenewIcon } from '@pancakeswap/uikit'
import { StyledBalanceMaxMini } from './styleds'
import { useNetwork } from 'wagmi'
import { formatSymbol, getChainId } from 'config/constants/exchange'

interface TradePriceProps {
  price?: Price
  showInverted: boolean
  setShowInverted: (showInverted: boolean) => void
}

export default function TradePrice({ price, showInverted, setShowInverted }: TradePriceProps) {
  const { chain } = useNetwork()
  const chainId = getChainId(chain)

  const formattedPrice = showInverted ? price?.toSignificant(6) : price?.invert()?.toSignificant(6)
  const show = Boolean(price?.baseCurrency && price?.quoteCurrency)



  const label = showInverted
    ? `${formatSymbol(price?.quoteCurrency?.symbol , chainId)} per ${formatSymbol(price?.baseCurrency?.symbol, chainId)}`
    : `${formatSymbol(price?.baseCurrency?.symbol, chainId)} per ${formatSymbol(price?.quoteCurrency?.symbol, chainId)}`

  return (
    <Text style={{ justifyContent: 'center', fontSize: '12px', alignItems: 'center', display: 'flex' }}>
      {show ? (
        <>
          {formattedPrice ?? '-'} {label}
          <StyledBalanceMaxMini onClick={() => setShowInverted(!showInverted)}>
            <AutoRenewIcon width="14px" />
          </StyledBalanceMaxMini>
        </>
      ) : (
        '-'
      )}
    </Text>
  )
}
